import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { SIA_NAVY } from '../../../constants/siaTheme'

const OBS_CURSOR_EYE =
    'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'22\' height=\'22\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23292d32\' stroke-width=\'2\'%3E%3Cpath d=\'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\'/%3E%3Ccircle cx=\'12\' cy=\'12\' r=\'3\'/%3E%3C/svg%3E") 11 11, zoom-in'

function formatDate(val) {
    if (!val) return ''
    const d = String(val).slice(0, 10)
    const [y, m, day] = d.split('-')
    if (!y || !m || !day) return val
    return `${day}/${m}/${y}`
}

function formatTime(val) {
    if (!val) return ''
    return String(val).slice(0, 5)
}

function fullName(row) {
    return [row.nombre, row.apellido_paterno, row.apellido_materno].filter(Boolean).join(' ')
}

function yesNo(val) {
    return val ? 'SÍ' : 'NO'
}

const RecruitmentIndex = ({ entries, filters, mode, recruiters }) => {
    const { flash } = usePage().props
    const manage = mode === 'manage'
    const [deleteTarget, setDeleteTarget] = useState(null)
    const [deleting, setDeleting] = useState(false)

    const filterForm = useForm({
        search: filters.search || '',
        user_id: filters.user_id || '',
        fecha_inicio: filters.fecha_inicio || '',
        fecha_fin: filters.fecha_fin || '',
        tipo_fecha: filters.tipo_fecha || 'registro',
    })

    const indexRoute = 'recruitment.index'
    const pathPrefix = 'admin/reclutamiento/registros'
    const cvRoute = 'recruitment.cv'

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route(indexRoute), { preserveState: true })
    }

    const clearFilters = () => {
        filterForm.setData({
            search: '',
            user_id: '',
            fecha_inicio: '',
            fecha_fin: '',
            tipo_fecha: 'registro',
        })
        filterForm.get(route(indexRoute))
    }

    const paginationFilters = {
        search: filters.search || undefined,
        user_id: filters.user_id || undefined,
        fecha_inicio: filters.fecha_inicio || undefined,
        fecha_fin: filters.fecha_fin || undefined,
        tipo_fecha: filters.tipo_fecha || undefined,
    }

    const confirmDelete = () => {
        if (!deleteTarget) return
        setDeleting(true)
        Inertia.delete(route('recruitment.destroy', deleteTarget.id), {
            preserveScroll: true,
            onFinish: () => {
                setDeleting(false)
                setDeleteTarget(null)
            },
        })
    }

    const data = entries.data || []

    const editHref = (row) =>
        route('recruitment.edit', row.id)

    const createHref = route('recruitment.create')

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath={pathPrefix} />
            </span>

            <div
                className="rounded-2 mb-8 py-4 px-4 text-center text-white text-uppercase fw-bold fs-4"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
            >
                Información sobre los prospectos
            </div>

            <div className="card card-flush h-md-100">
                <div className="card-header pt-7 flex-wrap gap-3">
                    <div className="card-toolbar ms-auto">
                        <Link href={createHref} className="btn btn-sm btn-primary">
                            Agregar registro
                        </Link>
                    </div>
                </div>

                <div className="card-body pt-6">
                    <Form onSubmit={submitFilters} className="d-flex flex-wrap align-items-end gap-3 mb-8">
                        <div className="flex-grow-1" style={{ minWidth: '200px', maxWidth: '360px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Buscar</label>
                            <Form.Control
                                type="search"
                                size="sm"
                                className="form-control-solid"
                                placeholder="Nombre, teléfono, zona…"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                            />
                        </div>
                        <div style={{ minWidth: '160px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Filtrar por</label>
                            <Form.Select
                                size="sm"
                                className="form-select-solid"
                                value={filterForm.data.tipo_fecha}
                                onChange={(e) => filterForm.setData('tipo_fecha', e.target.value)}
                            >
                                <option value="registro">Fecha de registro</option>
                                <option value="entrevista">Fecha de entrevista</option>
                            </Form.Select>
                        </div>
                        <div style={{ minWidth: '150px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Desde</label>
                            <Form.Control
                                type="date"
                                size="sm"
                                className="form-control-solid"
                                value={filterForm.data.fecha_inicio}
                                onChange={(e) => filterForm.setData('fecha_inicio', e.target.value)}
                            />
                        </div>
                        <div style={{ minWidth: '150px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Hasta</label>
                            <Form.Control
                                type="date"
                                size="sm"
                                className="form-control-solid"
                                value={filterForm.data.fecha_fin}
                                onChange={(e) => filterForm.setData('fecha_fin', e.target.value)}
                            />
                        </div>
                        {manage && recruiters && recruiters.length > 0 && (
                            <div style={{ minWidth: '180px' }}>
                                <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Reclutador</label>
                                <Form.Select
                                    size="sm"
                                    className="form-select-solid"
                                    value={filterForm.data.user_id}
                                    onChange={(e) => filterForm.setData('user_id', e.target.value)}
                                >
                                    <option value="">Todos</option>
                                    {recruiters.map((u) => (
                                        <option key={u.id} value={u.id}>
                                            {u.display_name || u.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        )}
                        <Button type="submit" size="sm" variant="primary" disabled={filterForm.processing}>
                            Buscar
                        </Button>
                        <Button type="button" size="sm" variant="light" onClick={clearFilters}>
                            Limpiar
                        </Button>
                    </Form>

                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-3 text-uppercase fs-8">
                            <thead>
                                <tr className="fw-bold text-white" style={{ backgroundColor: SIA_NAVY }}>
                                    {manage && <th className="min-w-140px ps-3">Reclutador</th>}
                                    <th className={manage ? 'min-w-90px' : 'min-w-90px ps-3'}>Fecha</th>
                                    <th className="min-w-180px">Nombre</th>
                                    <th className="min-w-100px">Teléfono</th>
                                    <th className="min-w-160px">Zona</th>
                                    <th className="min-w-140px">Posición</th>
                                    <th className="min-w-100px">F. entrevista</th>
                                    <th className="min-w-80px">Hora</th>
                                    <th className="min-w-120px">Medio reclut.</th>
                                    <th className="min-w-180px">Observaciones</th>
                                    <th className="min-w-80px">Veritas</th>
                                    <th className="min-w-80px">Finalizado</th>
                                    <th className="min-w-100px">F. ingreso</th>
                                    <th className="min-w-50px text-center">CV</th>
                                    <th className="min-w-70px text-center pe-3">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 && (
                                    <tr>
                                        <td className="text-center py-10 text-gray-700" colSpan={manage ? 15 : 14}>
                                            No hay registros.
                                        </td>
                                    </tr>
                                )}
                                {data.map((row, idx) => (
                                    <tr key={row.id} className={idx % 2 === 1 ? 'bg-light' : ''}>
                                        {manage && (
                                            <td className="ps-3 fw-semibold text-uppercase">
                                                {row.user?.display_name || row.user?.name || '—'}
                                            </td>
                                        )}
                                        <td className={manage ? '' : 'ps-3'}>{formatDate(row.fecha)}</td>
                                        <td className="fw-semibold">{fullName(row)}</td>
                                        <td>{row.telefono}</td>
                                        <td>{row.zona}</td>
                                        <td>{row.position?.name || '—'}</td>
                                        <td>{formatDate(row.fecha_entrevista)}</td>
                                        <td>{formatTime(row.hora_entrevista)}</td>
                                        <td>{row.source?.name || '—'}</td>
                                        <td>
                                            {row.observaciones ? (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip className="text-start">
                                                            <span style={{ whiteSpace: 'pre-wrap' }}>{row.observaciones}</span>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span
                                                        className="text-truncate d-inline-block border-bottom border-dashed"
                                                        style={{ maxWidth: '160px', cursor: OBS_CURSOR_EYE }}
                                                    >
                                                        {row.observaciones}
                                                    </span>
                                                </OverlayTrigger>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                        <td>{yesNo(row.aprobo_veritas)}</td>
                                        <td>{yesNo(row.proceso_finalizado)}</td>
                                        <td>{formatDate(row.fecha_ingreso)}</td>
                                        <td className="text-center">
                                            {row.cv_path ? (
                                                <a
                                                    href={route(cvRoute, row.id)}
                                                    className="btn btn-sm btn-icon btn-light-primary"
                                                    title="Descargar CV"
                                                >
                                                    <i className="bi bi-file-earmark-text fs-5" />
                                                </a>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                        <td className="text-center pe-3">
                                            <Link href={editHref(row)} className="btn btn-sm btn-icon btn-light-primary" title="Editar">
                                                <i className="bi bi-pencil-square fs-5" />
                                            </Link>
                                            {manage && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-icon btn-light-danger ms-1"
                                                    title="Eliminar"
                                                    onClick={() => setDeleteTarget(row)}
                                                >
                                                    <i className="bi bi-trash fs-5" />
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-center py-6">
                        <PaginationList links={entries.links} filters={paginationFilters} />
                    </div>
                </div>
            </div>

            {deleteTarget !== null && (
                <Modal show onHide={() => !deleting && setDeleteTarget(null)} centered>
                    <Modal.Header closeButton={!deleting}>
                        <Modal.Title>Confirmar eliminación</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Eliminar el registro de <strong>{deleteTarget ? fullName(deleteTarget) : ''}</strong>?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" disabled={deleting} onClick={() => setDeleteTarget(null)}>
                            Cancelar
                        </Button>
                        <Button variant="danger" disabled={deleting} onClick={confirmDelete}>
                            {deleting ? 'Eliminando…' : 'Eliminar'}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </Row>
    )
}

RecruitmentIndex.layout = (page) => <Layout title="Reclutamiento">{page}</Layout>

export default RecruitmentIndex
